import { render, staticRenderFns } from "./PremiumRenewalAlert.vue?vue&type=template&id=9ed227bc"
import script from "./PremiumRenewalAlert.vue?vue&type=script&lang=ts"
export * from "./PremiumRenewalAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports